import { useEffect, useState } from "react";
import { useTheme } from "@mui/material";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function LineChart(props) {
  const { hideLegend, label, heading, color, scales } = props;
  const theme = useTheme();
  const [data, setData] = useState(null);
  const options = {
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },
    stacked: false,
    plugins: {
      legend: {
        [hideLegend ? "display" : "position"]: hideLegend ? false : "top",
      },
      title: {
        display: Boolean(heading),
        text: heading || "Line Chart",
      },
    },
    scales: scales || {
      y: { type: "linear", display: true, position: "left" },
    },
  };
  useEffect(() => {
    let labels = [];
    let datasets = [];
    if (!props.data?.length && !props.datasets?.length) {
    } else if (props.stacked) {
    } else {
      labels = props.labels || props.data.map((el) => el.x);
      datasets = props.datasets
        ? props.datasets.map((el, index) => {
            return {
              backgroundColor:
                theme.palette[`chartColor${(index % 5) + 1}`].light,
              borderColor: theme.palette[`chartColor${(index % 5) + 1}`].dark,
              ...el,
            };
          })
        : [
            {
              label: label || heading || "Line Chart",
              data: props.data.map((el) => el.y),

              backgroundColor: props.data.map(
                (el) =>
                  el.backgroundColor ||
                  (color && color.includes("#")
                    ? color
                    : theme.palette[color || `chartColor1`].light)
              ),
              borderColor: props.data.map(
                (el) =>
                  el.borderColor ||
                  (color && color.includes("#")
                    ? color
                    : theme.palette[color || `chartColor1`].dark)
              ),
              borderWidth: 1,
            },
          ];
    }

    setData({
      labels,
      datasets,
    });
    // eslint-disable-next-line
  }, [props]);
  if (!data) return <></>;
  return <Line options={options} data={data} />;
}
